import { render } from "./PublicIcon.vue?vue&type=template&id=7a2e6ac2&scoped=true"
import script from "./PublicIcon.vue?vue&type=script&lang=js"
export * from "./PublicIcon.vue?vue&type=script&lang=js"

import "./PublicIcon.vue?vue&type=style&index=0&id=7a2e6ac2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2e6ac2"]])

export default __exports__